<template>
  <div v-if="posterImageStatus" class="poster-first">
    <div class="poster-pop" v-show="!canvasStatus">
      <img
        src="@assets/images/poster-close.png"
        class="close"
        @click="posterImageClose"
      />
      <div class="canvas " ref="poster" id="canvasBox">
        <div class="rel" v-if="posterData.qr">
          <img class="image" :src="posterData.qr" alt="商品图片" />
          <img
            v-if="posterData.avatar"
            :src="posterData.avatar"
            class="abs avatar"
            alt="二维码"
          />
        </div>
      </div>
      <!--<div class="save-poster" @click="savePosterPath">生成图片</div>-->
    </div>
    <div
      class="poster-pop"
      v-show="canvasStatus"
      :style="'margin-top:' + marginTop"
    >
      <img
        src="@assets/images/poster-close.png"
        class="close"
        @click="posterImageClose"
      />
      <img :src="posterImage" alt="tp" class="poster-image" />
      <div class="keep">长按图片可以保存到手机</div>
    </div>
    <div class="mask" @click="posterImageClose"></div>
  </div>
</template>
<style scoped lang="scss">
.poster-first {
  overscroll-behavior: contain;
}
.avatar {
  $wa: 1rem;
  width: $wa;
  height: $wa;
  top: calc(50% - 0.5rem);
  left: calc(50% - 0.5rem);
  border-radius: 0.08rem;
}

.poster-pop {
  width: 5rem;
  height: auto;
  position: fixed;
  left: 50%;
  transform: translateX(-50%);
  z-index: 99;
  top: 50%;
  margin-top: -50%;
}

.poster-pop .canvas {
  box-sizing: content-box;
}
.poster-pop .poster-image {
  width: 100%;
}
.poster-pop .canvas .image {
  width: 100%;
  height: auto;
  display: block;
}

.poster-pop .code-img {
  text-align: center;
  bottom: 0.15rem;
}
.poster-pop .canvas .code-img img {
  width: 18%;
}
.poster-pop .canvas .code-text {
  text-align: center;
  font-size: 0.22rem;
  color: #ffffff;
}
.poster-pop .close {
  width: 0.46rem;
  height: 0.75rem;
  position: fixed;
  z-index: 9999;
  right: 0;
  top: -0.5rem;
  display: block;
  z-index: -1;
}

.poster-pop .keep {
  color: #fff;
  text-align: center;
  font-size: 0.25rem;
  margin-top: 0.1rem;
}
.mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 9;
}
</style>
<script>
import html2canvas from "html2canvas";
let canvas, canvasBox, optionsCanves;
export default {
  name: "MyQr",
  props: {
    posterImageStatus: Boolean,
    posterData: Object
  },
  data: function() {
    return {
      canvasStatus: false,
      marginTop: "-5rem"
    };
  },
  watch: {
    posterImageStatus() {
      console.log(this.posterData);
      if (this.posterImageStatus === true) {
        this.$dialog.loading.open();
        setTimeout(() => {
          this.setHtml2Canvas();
        }, 2000);
      } else {
        this.$dialog.loading.close();
      }
    }
  },
  mounted: function() {
    //   console.log('this.posterData.userInfo-0',this.posterData.userInfo)
    // if (this.posterData.userInfo && this.posterData.userInfo.avatar) {
    //     console.log('this.posterData.userInfo',this.posterData.userInfo)
    //   imgNameArr["userlogo"] = 0;
    // }
  },
  methods: {
    getLogo(logo) {
      return logo.replace(/\/\d+$/, "/64");
    },
    posterImageClose: function() {
      this.posterImageStatus = false;
      this.canvasStatus = false;

      this.$emit("setPosterImageStatus");
    },
    // loadimgOk(name) {
    //   let ok = true;
    //   console.log("name", name);
    //   for (let x in imgNameArr) {
    //     if (x === name) imgNameArr[x] = 1;
    //     if (!imgNameArr[x]) ok = false;
    //   }
    //   if (!ok) {
    //     return;
    //   }
    //   this.savePosterPath();
    // },
    savePosterPath: function() {
      this.setHtml2Canvas();
    },
    setHtml2Canvas() {
      canvas = document.createElement("canvas");
      canvasBox = document.getElementById("canvasBox");
      const width = parseInt(window.getComputedStyle(canvasBox).width);
      const height = parseInt(window.getComputedStyle(canvasBox).height);
      console.log("width", width, "height", height);
      if (!width) {
        return;
      }
      canvas.width = width * 2;
      canvas.height = height * 2;

      canvas.style.width = width + "px";
      canvas.style.height = height + "px";
      this.marginTop = -height / 2 - 30 + "px";

      const context = canvas.getContext("2d");
      context.scale(0.6, 2);
      optionsCanves = {
        backgroundColor: null,
        canvas,
        allowTaint: true,
        useCORS: true,
        imageTimeout: 8000,
        logging: true
      };
      html2canvas(canvasBox, optionsCanves)
        .then(canvas => {
          this.posterImage = canvas.toDataURL();
          this.canvasStatus = true;
          this.$dialog.loading.close();
        })
        .catch(err => {
          console.log("err", err);
          if (this.useAvatar) {
            this.useAvatar = false;
            setTimeout(() => {
              this.setHtml2Canvas();
            }, 500);
            return;
          } else if (!confirm("生成失败 是否尝试继续生成海报？")) {
            this.posterImageClose();
            return;
          }
          this.setHtml2Canvas();
        });
    }
  }
};
</script>
